import * as yup from "yup";
export const identitySchema = (identityFormOptions, optionalName) => {
  const shape = {
    features: yup.string().notRequired(),
    forename: optionalName
      ? yup.string().notRequired()
      : yup.string().required("First name is required"),
    surname: yup.string().notRequired(),
  };

  const mappings = {
    hasDateOfBirth: {
      type: yup.string(),
      name: "dateOfBirth",
    },
    hasGender: {
      type: yup.object(),
      name: "gender",
    },
    hasAgeRange: {
      type: yup.object(),
      name: "ageRange",
    },
    hasHeight: {
      type: yup.object(),
      name: "height",
    },
    hasBuild: {
      type: yup.object(),
      name: "build",
    },
    hasHair: {
      type: yup.object(),
      name: "hair",
    },
    hasEthnicity: {
      type: yup.object(),
      name: "ethnicity",
    },
    hasPhoneNumber: {
      type: yup.string(),
      name: "phoneNumber",
    },
    hasEmailAddress: {
      type: yup.string().email(),
      name: "emailAddress",
    },
  };

  for (const [key, value] of Object.entries(
    identityFormOptions.customerConfiguration ?? {
      propertyConfigurationTypes: [],
    },
  )) {
    if (!key.startsWith("has")) {
      continue;
    }

    if (!mappings[key]) {
      continue;
    }

    const { show, required } =
      identityFormOptions.customerConfiguration.propertyConfigurationTypes.find(
        (type) => {
          return type.id === value;
        },
      ) ?? { show: false, required: false };

    if (!show) {
      continue;
    }

    const { type, name } = mappings[key];

    if (!type || !name) {
      continue;
    }

    shape[name] = required ? type.required() : type.notRequired();
  }

  return yup.object().shape(shape);
};
